export class PreCandidato {
    constructor(
        public id?: number,
        public email?: string, 
        public nome?: string,
        public imagem?: string,
        public curriculum?: string,
        public cpf?: string,
        public cargoId?: number,
        public cargo?: any,
        public candidatura?: any,
        public statusAnalise?: string,
        public dataHoraEnvioEmail?: Date,
        public justificativaIndeferimento?: string,
        public selecionado?: boolean,
        public observacoes?: string,
        public formularioPreenchido?: boolean,
        public login?: boolean,
    ) {

    }
}

